<template>
  <div>
    <input type="text" className="form-control" placeholder="" v-model="propsValue">
    <h1>藥物處方</h1>



    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>商品名</th>
        <th>藥品名稱</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td >
          <a class="btn btn-danger" href="#"><i class="fa fa-trash"></i></a>
        </td>
        <td>
          止痛錠
        </td>
        <td>
          Acetaminophen     500 mg/tab
        </td>
        <td>

        </td>
      </tr>
      <tr>
        <td colspan="4">
          每天4次，飯前，早/中/晚/睡前  (郭漢崇醫師)
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
        <th class="text-center">藥品</th>
        <th>用法</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td >
          <select class="form-control" id="selItems" name="selItems">
            <option>止痛錠	Acetaminophen     500 mg/tab</option>
            <option>驅炎寧	Diclofenac              25 mg/tab</option>
            <option>肌緩痛	Mocolax               400 mg/tab</option>
            <option>弛刻達	Sketa                250mg & 300 mg/cap</option>
            <option>妥美亭	Tramacet             37.5 & 325  mg/tab</option>
            <option>優力黴素膠囊	Cephalexin            500 mg/cap</option>
            <option>悅潰止	Famotidine             20 mg/tab</option>
            <option>艾來	Fexofenadine          60 mg/tab</option>
            <option>胃明朗	Metoclopramide  3.84 mg/tab</option>
            <option>利都   卡因	Lidocaine              2% 20 mL/vial</option>
            <option>臨得隆 	Betamethasone          1 mL/amp</option>
            <option>臨得隆 	Rinderon-V           5g/條/乳膏</option>
            <option>欣黴素藥膏	Biomycin  Ointment  40g/tube</option>
            <option>強力施美藥膏	CB Ointmint             5 gm/tube</option>
            <option>止膿敏       點眼液	Sinomin Oph         4% 15 mL/bt</option>
            <option>燙膚舒乳膏	Siliverzine cream          20 g/tube</option>
          </select>
        </td>
        <td >
          <MedicineUsageWay></MedicineUsageWay>
        </td>
      </tr>

      </tbody>
    </table>
    <a class="btn btn-primary" href="#"><i class="fa fa-plus-circle"></i> 新增</a>
  </div>
</template>

<script>/**

 **/
import MedicineUsageWay from "@/views/rcc/component/MedicineUsageWay.vue";


export default {
  components: {MedicineUsageWay},
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
